var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addresses"},[_vm._l((_vm.combinedAddresses.slice(0,3)),function(address){return _c('Address',{key:JSON.stringify(address),attrs:{"value":address}})}),_vm._v(" "),(_vm.combinedAddresses.length > 3)?_c('div',{staticClass:"more"},[_vm._v("..."+_vm._s(_vm.combinedAddresses.length - 3)+" more...")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ed431a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/settings/ViewAddresses.vue
// module id = 1OZg
// module chunks = 1